/**
 * NotLost mark: a shield (safe, trusted) holding a location pin (found, on
 * its way home). Original artwork, single colour so it works at favicon size.
 */
export function Logo({ size = 32, tone = 'blue' }: { size?: number; tone?: 'blue' | 'white' }) {
  const fill = tone === 'blue' ? '#0071E3' : '#FFFFFF';
  const cut = tone === 'blue' ? '#FFFFFF' : '#0071E3';
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <path d={SHIELD} fill={fill} />
      <path d={PIN} fill={cut} />
      <circle cx="32" cy="28.5" r="4.2" fill={fill} />
    </svg>
  );
}

export const SHIELD = 'M32 3.5 L55 10.5 V30 C55 45.5 45.2 55.6 32 60.5 C18.8 55.6 9 45.5 9 30 V10.5 Z';
export const PIN =
  'M32 16.5 c-6.9 0 -11.6 5 -11.6 11.4 c0 8 11.6 19.6 11.6 19.6 s11.6 -11.6 11.6 -19.6 c0 -6.4 -4.7 -11.4 -11.6 -11.4 z';

/** Wordmark: lowercase, tight, period in brand blue. */
export function Wordmark({ tone = 'ink', className = '' }: { tone?: 'ink' | 'white'; className?: string }) {
  return (
    <span className={`whitespace-nowrap text-[19px] font-semibold tracking-[-0.03em] ${tone === 'ink' ? 'text-ink' : 'text-white'} ${className}`}>
      not lost<span className={tone === 'ink' ? 'text-blue' : 'text-night-link'}>.</span>
    </span>
  );
}

export function Brand({ tone = 'ink' }: { tone?: 'ink' | 'white' }) {
  return (
    <a href="/" className="inline-flex items-center gap-2" aria-label="not lost. home">
      <Logo size={26} tone={tone === 'ink' ? 'blue' : 'white'} />
      <Wordmark tone={tone} />
    </a>
  );
}

export function ShieldCheck({ className = 'h-4 w-4' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path d="M12 2 4 5v6.2c0 5 3.4 9.4 8 10.8 4.6-1.4 8-5.8 8-10.8V5l-8-3z" fill="currentColor" opacity="0.18" />
      <path
        d="M12 2 4 5v6.2c0 5 3.4 9.4 8 10.8 4.6-1.4 8-5.8 8-10.8V5l-8-3z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="m8.5 12 2.4 2.4 4.6-4.8" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function PinIcon({ className = 'h-6 w-6' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path
        d="M12 2c-3.9 0-7 3-7 6.9C5 14 12 22 12 22s7-8 7-13.1C19 5 15.9 2 12 2zm0 9.6a2.6 2.6 0 1 1 0-5.2 2.6 2.6 0 0 1 0 5.2z"
        fill="currentColor"
      />
    </svg>
  );
}
